import React, { useContext } from 'react';
import { FedopsLogger } from '@wix/fedops-logger';
import { InteractionName } from '../../../types/InteractionName';

export type WidgetFedopsLogger = FedopsLogger<InteractionName>;
export interface Props {
  fedopsLogger: FedopsLogger<InteractionName>;
  children: React.ReactNode;
}

export const FedopsContext = React.createContext<WidgetFedopsLogger>(null);

export class FedopsProvider extends React.Component<Props> {
  render() {
    return <FedopsContext.Provider value={this.props.fedopsLogger}>{this.props.children}</FedopsContext.Provider>;
  }
}

export const useFedopsLogger = (): WidgetFedopsLogger => {
  const value = useContext(FedopsContext);
  return value;
};
